import { render, staticRenderFns } from "./BookChannelConfig.vue?vue&type=template&id=4c9f3d5f&scoped=true"
import script from "./BookChannelConfig.vue?vue&type=script&lang=js"
export * from "./BookChannelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f3d5f",
  null
  
)

export default component.exports